import { Theme } from "../../../components/constants";

export default {
    formDivFullWidth:{
        width: "100%",
    },
    stepTitleContainer:{
        textAlign: "center",
        marginTop: "10px",
    },
    stepTitleDesc: {
        fontSize: "16px",
        lineHeight: "25px",
        color: Theme.DISABLED_TEXT
    },
    cardsGroupContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "15px",
        margin: "35px 0px",
        justifyContent: "center",
    },
    cardContainer:{
        cursor: "pointer"
    },
    individualCardStyle: {
        height: "220px",
        width: "220px",
    },
}